import { useState } from "react";
import { useAuth } from "../context/AuthContext";
import { Link } from "react-router-dom";

const INITIAL_FORM = {
  nome: "",
  email: "",
  cpf_cnpj: "",
  erp_cliente_id: "",
  senha: "",
  confirmar_senha: "",
};

// Mesma lógica de máscara que estava no <script> do cadastro.php original
function aplicarMascaraCpfCnpj(valorDigitado) {
  let v = valorDigitado.replace(/\D/g, "").slice(0, 14);
  if (v.length <= 11) {
    v = v
      .replace(/(\d{3})(\d)/, "$1.$2")
      .replace(/(\d{3})(\d)/, "$1.$2")
      .replace(/(\d{3})(\d{1,2})$/, "$1-$2");
  } else {
    v = v
      .replace(/(\d{2})(\d)/, "$1.$2")
      .replace(/(\d{3})(\d)/, "$1.$2")
      .replace(/(\d{3})(\d)/, "$1/$2")
      .replace(/(\d{4})(\d{1,2})$/, "$1-$2");
  }
  return v;
}

export default function Cadastro() {
  const { cadastrar } = useAuth();

  const [form, setForm] = useState(INITIAL_FORM);
  const [erro, setErro] = useState("");
  const [sucesso, setSucesso] = useState("");
  const [enviando, setEnviando] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "cpf_cnpj") {
      setForm((prev) => ({ ...prev, cpf_cnpj: aplicarMascaraCpfCnpj(value) }));
      return;
    }

    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErro("");
    setSucesso("");
    setEnviando(true);

    const res = await cadastrar(form);
    setEnviando(false);

    if (res.ok) {
      setSucesso(res.mensagem || "Cadastro realizado com sucesso!");
      setForm(INITIAL_FORM);
    } else {
      setErro(res.erro || "Não foi possível concluir o cadastro.");
    }
  };

  return (
    <section
      className="section"
      style={{ minHeight: "80vh", display: "flex", alignItems: "center" }}
    >
      <div className="container" style={{ maxWidth: "460px" }}>
        <div className="card" style={{ "--accent": "#0066FF", padding: "40px" }}>
          <div className="tag">Acesso</div>
          <h1
            className="section-title"
            style={{ fontSize: "28px", marginBottom: "8px", color: "var(--text-primary)" }}
          >
            Criar conta
          </h1>
          <p className="section-subtitle" style={{ marginBottom: "28px" }}>
            Cadastre-se para acessar a área do cliente sepolTECH.
          </p>

          {erro && (
            <div
              style={{
                background: "rgba(239,68,68,.1)",
                border: "1px solid rgba(239,68,68,.3)",
                color: "var(--error)",
                padding: "12px 16px",
                borderRadius: "8px",
                marginBottom: "20px",
                fontSize: "14px",
              }}
            >
              {erro}
            </div>
          )}

          {sucesso && (
            <div
              style={{
                background: "rgba(34,197,94,.1)",
                border: "1px solid rgba(34,197,94,.3)",
                color: "var(--success)",
                padding: "12px 16px",
                borderRadius: "8px",
                marginBottom: "20px",
                fontSize: "14px",
              }}
            >
              {sucesso}{" "}
              <Link to="/login" style={{ color: "var(--success)", textDecoration: "underline" }}>
                Ir para login →
              </Link>
            </div>
          )}

          <form className="contact-form" onSubmit={handleSubmit}>
            <div className="form-group">
              <label>Nome completo</label>
              <input
                type="text"
                name="nome"
                required
                value={form.nome}
                onChange={handleChange}
              />
            </div>
            <div className="form-group">
              <label>E-mail</label>
              <input
                type="email"
                name="email"
                required
                value={form.email}
                onChange={handleChange}
              />
            </div>
            <div className="form-group">
              <label>CPF ou CNPJ</label>
              <input
                type="text"
                name="cpf_cnpj"
                required
                maxLength={18}
                placeholder="000.000.000-00"
                value={form.cpf_cnpj}
                onChange={handleChange}
              />
            </div>
            <div className="form-group">
              <label>
                ID do Cliente no ERP{" "}
                <span style={{ color: "var(--text-muted)", fontWeight: 400 }}>
                  (opcional)
                </span>
              </label>
              <input
                type="number"
                name="erp_cliente_id"
                min="1"
                placeholder="Ex: 50"
                value={form.erp_cliente_id}
                onChange={handleChange}
              />
              <p style={{ fontSize: "11.5px", color: "var(--text-muted)", marginTop: "4px" }}>
                É o "id" desse cliente na tabela <code>clientes</code> do
                sistema de propostas/contratos. Deixe em branco se o cliente
                ainda não estiver cadastrado lá.
              </p>
            </div>
            <div className="form-group">
              <label>Senha</label>
              <input
                type="password"
                name="senha"
                required
                minLength={6}
                value={form.senha}
                onChange={handleChange}
              />
            </div>
            <div className="form-group">
              <label>Confirmar senha</label>
              <input
                type="password"
                name="confirmar_senha"
                required
                minLength={6}
                value={form.confirmar_senha}
                onChange={handleChange}
              />
            </div>
            <button
              type="submit"
              className="btn btn-primary"
              disabled={enviando}
              style={{
                marginTop: "8px",
                border: "none",
                cursor: enviando ? "default" : "pointer",
                width: "100%",
                textAlign: "center",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                opacity: enviando ? 0.7 : 1,
              }}
            >
              {enviando ? "Enviando..." : "Cadastrar →"}
            </button>
          </form>

          <p
            style={{
              fontSize: "13px",
              color: "var(--text-muted)",
              marginTop: "20px",
              textAlign: "center",
            }}
          >
            Já tem conta?{" "}
            <Link to="/login" style={{ color: "var(--brand-blue)" }}>
              Fazer login
            </Link>
          </p>
        </div>
      </div>
    </section>
  );
}
